import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TipoPratica } from "../../../../../../../common/models/tipologiche/tipo-pratica";
import { Observable } from "rxjs";
import { CreazionePraticaTipologicheService } from "../../../../services/creazione-pratica-tipologiche.service";
import { Router } from "@angular/router";
import { PdaUtils } from "src/app/pda/utils/pda-utils";

@Component({
  selector: "tipo-pratica-widget",
  templateUrl: "./tipo-pratica-widget.component.html",
  styleUrls: ["./tipo-pratica-widget.component.css"],
})
export class TipoPraticaWidgetComponent implements OnInit {
  tipiPraticaOptions: TipoPratica[];
  @Input() tipoPratica: TipoPratica;
  @Input() tipoPraticaSugg: string;
  @Output() tipoPraticaChange: EventEmitter<TipoPratica> =
    new EventEmitter<TipoPratica>();

  constructor(private tipologicheService: CreazionePraticaTipologicheService, private router: Router) {
    this.tipologicheService.getTipiPratica().subscribe((res) => {
      if (router.url.endsWith("consultazione")) {
        this.tipiPraticaOptions = res.filter(
          (elem) =>
            !!PdaUtils.getPdaComboModelbyLabelTipoPratica(elem.label)
        );
      } else {
        this.tipiPraticaOptions = res;
      }
    });
  }

  ngOnInit() {
    //console.log('[INIT WIDGET]')
  }

  setTipoPratica(tipoPratica: TipoPratica) {
    this.tipoPraticaChange.emit(tipoPratica);
  }

  formatLabel(label: string): string {
    const found = this.tipiPraticaOptions.find((el) =>
      el.label.startsWith(label.toUpperCase())
    );
    return found ? found.label : "-";
  }
}
